// // import React from 'react'
// // import Layout from '../components/Layout'
// // import { useSelector } from 'react-redux';
// // import Drawer from '../components/Drawer';

// // const TermsAndCondition=()=> {
// //       const { lang } = useSelector((state) => state.langSlice);

// //   return (
// //     <Layout active={8}>
// //       <Drawer active={8}/>
// //      <div className=" mt-6 p-6 max-w-5xl mx-auto bg-white dark:bg-gray-900 text-gray-800 dark:text-white rounded-lg shadow-md">
// //       <h1 className="text-4xl font-bold  flex justify-center items-center">Kickwinn Terms And Conditions   
// // </h1>
// //     <div className="space-y-6  bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">

// //            <p className="text-sm leading-relaxed lg:mt-5 md:6 mt-12">
// //           <strong>NOTE:</strong> The following Terms and Conditions contain assumptions of risk and/or liability by you and limit and exclude liabilities, obligations and legal responsibilities which Formal Grand Resources (Pvt) Ltd ("FGR") referred to as the ("Promoters") will have towards you and other persons. These Terms and Conditions also limit and exclude your rights and remedies against the Promoters and place various risks, liabilities, obligations and legal responsibilities on you. These Terms and Conditions may result in you being responsible for paying additional costs and amounts and the Promoters may also have claims and other rights against you.
// // Please read these Terms and Conditions carefully. Participation in this offer will constitute your agreement to comply with these Terms and Conditions. If you do not agree with these Terms and Conditions, please do not participate in this offer. It is specifically understood that Participation in the offer is qualified by your acceptance of the Terms and Conditions by way of click through thereof on your device

// //         </p>
  
// //   <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
// //     <h2 className="text-2xl font-semibold mb-4">
// //       <span className="mr-2 text-blue-500 ">→</span> 1. Introduction
// //     </h2>
// //     <p>Kickwinn is an interactive soccer portal that delivers live match scores, upcoming match schedules, and past match results. It features an engaging contest mode where users can create fantasy teams using real-time players and compete to win rewards such as Econet airtime.</p>
// //     <p className="mt-2">Specifically designed for sports enthusiasts, Kickwinn turns every game into an exciting and rewarding experience, enhancing fan engagement.</p>
// //     <p className="mt-2">Exclusively available to Econet subscribers, the service is offered via daily, weekly, and monthly subscriptions at:</p>
// //     <ul className="list-disc list-inside ml-4 mt-1">
// //       <li>ZWG 2.02 / 8.08 / 24.25</li>
// //       <li>USD 0.03 / 0.10 / 0.30</li>
// //     </ul>
// //     <p className="mt-2">Subscribers earn points that accumulate on a leaderboard.</p>
// //     <p>The top 20 users on the leaderboard each week win guaranteed prizes in the form of Econet airtime.</p>
// //   </section>


// //   <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
// //     <h2 className="text-2xl font-semibold mb-4">
// //       <span className="mr-2 text-blue-500">→</span> 2. Duration
// //     </h2>
// //     <p><b>2.1</b> The Service is available from 23 May 2025 until such a time that the Promoters in their sole and absolute discretion elect to discontinue the Service.</p>
  
// //   </section>


// //   <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
// //     <h2 className="text-2xl font-semibold mb-4">
// //       <span className="mr-2 text-blue-500">→</span> 3. Who is Eligible
// //     </h2>
// //     <p><b>3.1</b> The Service is available to all Econet’s subscribers who are natural persons with a valid Econet mobile number (“the Users”). Notwithstanding the aforesaid, it is agreed that only the Users who are using SIM cards to participate in the Service that have been RICA registered are eligible to win the Prizes.</p>
  
// //   </section>


// //   <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300 ">
// //     <h2 className="text-2xl font-semibold mb-4">
// //       <span className="mr-2 text-blue-500">→</span> 4. Subscription Methods
// //     </h2>
// //     <p> <b>4.1</b> Users must subscribe to the Service by accessing the subscription page:{" "}
// //   <a
// //     href="http://vod.kickwinn.com/"
// //     target="_blank"
// //     rel="noopener noreferrer"
// //     className="text-blue-600 underline hover:text-blue-800"
// //   >
// //     http://vod.kickwinn.com/
// //   </a>{" "}
// //   and upon successful subscription the user will receive a successful subscription notification message along with the link to the kickwinn portal.
// // </p>

// //           <p>
// //             <b>4.2</b> After subscribing to the Service, the Users can see the soccer matches scores as many times as they feel like.
// //           </p>
// //           <p>
// //             To promote the service the Promoters are running a competition where:
// //           </p>
// //           <p>
// //             <b>4.3</b> Top 20 winners will be selected by the Promoters at the end of each week for the weekly airtime.
// //           </p>

// //           <p>
// //             Airtime prizes will be automatically disbursed into the User’s mobile number that is subscribed to the service. Cash payments will be paid directly into the User’s mobile number that is subscribed to the service via EcoCash or any equivalent electronic payment channel. All verification and disbursements of prizes to winners will be done within 30 (thirty) days from the close of each competition
// //           </p>

// //           <p>
// //             <b>4.4</b>In instance where the winner cannot be determined due to multiple users with the same score, the user who first achieved the best score, will be announced as the winner.
// //           </p>

// //           <strong>
// //             Service Cancellation/Unsubscribing:
// //           </strong>

// //          <p>
// //   <b>4.5</b> Users can unsubscribe any time via{" "}
// //   <a
// //     href="http://vod.kickwinn.com/"
// //     target="_blank"
// //     rel="noopener noreferrer"
// //     className="text-blue-600 underline hover:text-blue-800"
// //   >
// // http://vod.kickwinn.com/
// //   </a>
// // </p>
// //           <p>
// //             <b>4.6</b> Users will receive an SMS confirming their cancellation of the service. It is the User’s obligation to ensure that they receive the SMS confirming their cancellation as the Service may continue should such confirmation not be received and the Promoters will not be liable for any loss incurred by the User in such instances.
// //           </p>

          
// //           <p>
// //             <b>4.7</b> Should a user unsubscribe from the service BEFORE the End date of each competition period, then he/she is NOT eligible to win the prize.
// //           </p>
   
// //   </section>


// //   <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
// //     <h2 className="text-2xl font-semibold mb-4">
// //       <span className="mr-2 text-blue-500">→</span> 5.Prizes
// //     </h2>
// //    <p><b>5.1</b> Winners stand a chance to win the following prizes:</p>
// //           <ul className="list-disc ml-6">
// //             <li>Weekly Airtime Prizes (USD): $5</li>
// //             <li>Weekly Airtime Prizes (ZWG): 185</li>
// //           </ul>
// //   </section>


// // <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
// //   <h2 className="text-2xl font-semibold mb-4">
// //     <span className="mr-2 text-blue-500">→</span> 6.10 Disclaimer
// //   </h2>
// // <p>
// //             <strong>6.1</strong> Charges will be applied to your mobile operator bill or be deducted from your prepaid or postpaid account (as the case may be) balance until you cancel the service. You must verify that your mobile handset has messaging and mobile internet capability.
// //           </p>

// //           <p>
// //             <strong>6.2</strong> The Service begins immediately after the User signs up for the subscription to the Service and will continue until the User requests to stop the Service and has received confirmation to that effect. As long as the service is not cancelled the User will be charged for it. The service is without obligation and can be stopped at any time.
// //           </p>

// //           <p>
// //             <strong>6.3</strong> The Promoters, their respective directors, affiliates, members, partners, employees, agents, consultants, suppliers, contractors, subsidiaries and sponsors assume no liability whatsoever for any direct or indirect loss or damage, including but not limited to physical harm or death, financial or pecuniary loss howsoever arising from or as a result of a person's participation in the Service and/or the terms and conditions of this Competition. The Promoters do not make any monetary or earnings claims in respect of the Services and do not guarantee any form of statements of earnings from the Services notwithstanding any form of advertising attached thereto. All participation in the Service shall be at the User’s sole risk. Accordingly, to the fullest extent permitted by law, the Promoters shall not be liable for any loss of revenue, savings, profit, income or any form of financial exposure due to the participation in the Services nor for any direct, indirect, special damages whether arising out of breach of contract, delict, product or service liability or otherwise regardless of how such loss arose or if it was foreseeable or not. Furthermore, you will be solely responsible for all products and services used by you. Accordingly, the Promoters takes no responsibility for any loss or damage, or any Econet airtime associated with the SIM card and/or cellphone number. In the event of theft or loss of your cellphone, airtime and/or SIM card, such items must be replaced at your own cost, and you are obliged to report such loss or theft to the Zimbabwe Republic Police immediately. All persons using the Service hereby expressly indemnify the Promoters in this regard and shall hold it harmless from all and any claims arising from or as a result of the above reasons. The provisions hereof shall survive termination of this agreement.
// //           </p>

// //           <p>
// //            <strong> 6.4 </strong>The Users agree that all trademarks, copyright and other intellectual property rights used or embodied in the Service shall remain vested solely with the Promoters. The Users shall not in any way attempt to decompile or reserve engineer any of the IP contained therein.
// //           </p>

// //           <p>
// //             <strong>6.5</strong> The Promoters reserve the right, at any time, to change these Terms and Conditions and any rules relating to its products and the Service, and to modify the Services at its discretion as they see fit without notice.
// //           </p>

// //           <p>
// //            <strong> 6.6 </strong>The Promoters reserve the right at any time to modify, suspend or discontinue the Service, without notice, without liability to you or any third party. The Promoters will under no circumstance be liable to you for any error, delay, failure, or non-availability of the Service, and you indemnify the Promoter against any damage or loss you may sustain as a result of possession and/or use of the SIM card, Econet network services, or any error, delay, failure or non-availability of the service. Visit http://vod.kickwinn.com/terms regularly for notices, updates and/or changes to the Service.
// //           </p>

// //           <p>
// //            <strong> 6.7</strong> The Promoters reserve the right from time to time to vary the charges of the Service as may be deemed necessary in its discretion provided that the User shall obtain notification in respect thereof.
// //           </p>

// //           <p>
// //            <strong>6.8</strong> See http://vod.kickwinn.com/ /terms for Service rules and updated Terms and Conditions from time to time. Any changes to rules and/or Terms and Conditions are effective from the date that they are published on the website.
// //           </p>

// //           <p>
// //           <strong>6.9 </strong> The Promoter shall be entitled to terminate the Service of any User or withhold any prizes, if such User is in breach of any of these Terms and Conditions or involved in any unlawful or fraudulent activity or suspected unlawful or fraudulent activity, or if these Terms and Conditions have not been fully adhered to or if it detects any irregularities or fraudulent practices.
// //           </p>

// //           <p>
// //            <strong>6.10</strong>  The Promoters are not liable for any technical failures affecting participation and / or prize redemption process of the Competition.  In addition, the promoters shall not be responsible for any loss or misdirected entries, incorrect information submitted including entries that were not received due to any failure of hardware, software, or other computer or technical systems affecting participating in and/or the prize redemption process of the Competition.
// //           </p>
// // </section>


// // <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
// //   <h2 className="text-2xl font-semibold mb-4">
// //     <span className="mr-2 text-blue-500">→</span> 6.11 How to Contact Us
// //   </h2>
// //   <p>
// //     Your feedback matters to us. Should you have any queries, please contact the Econet Call Centre. Please ensure that all queries are directed to the indicated helpline number and/or channel as updated from time to time. No emails, messages or texts sent to any other contact number(s) of either of the Promoters shall be open for queries. Accordingly, no queries shall be responded to unless directed to the indicated helpline numbers.
// //   </p>
// // </section>

// // </div>
// // </div>

// //     </Layout>
// //   );
// // }

// // export default TermsAndCondition



// import logoAnimation from "../animations/logo.json";
// import Lottie from "lottie-react";



// import React from 'react'
// import Layout from '../components/Layout'
// import { useSelector } from 'react-redux';
// import Drawer from '../components/Drawer';

// const TermsAndCondition=()=> {
//       const { lang } = useSelector((state) => state.langSlice);

//   return (
//     // <Layout active={8}>
//     <>
//       {/* <Drawer active={8}/> */}
//      <div className="  p-6 max-w-5xl mx-auto bg-white dark:bg-gray-900 text-gray-800 dark:text-white rounded-lg shadow-md">
//      <div className="flex">
//       <div 
//      className=' h-[5rem] w-[5rem]'
//      >
//                 <Lottie
//                   animationData={logoAnimation}
//                   loop={true}
//                   autoplay={true}
//                       style={{ height: "10vh"}}

//                   // className='h-[5rem'
                
//                 />
//                 </div>
//                 <h1 className="text-4xl font-bold  flex justify-center items-center">Kick n Winn Terms And Conditions   
// </h1>
//      </div>
    
              
      
//     <div className="space-y-6  bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">

//            {/* <p className="text-sm leading-relaxed lg:mt-5 md:6 mt-12">
//           <strong>NOTE:</strong> The following Terms and Conditions contain assumptions of risk and/or liability by you and limit and exclude liabilities, obligations and legal responsibilities which Formal Grand Resources (Pvt) Ltd ("FGR") referred to as the ("Promoters") will have towards you and other persons. These Terms and Conditions also limit and exclude your rights and remedies against the Promoters and place various risks, liabilities, obligations and legal responsibilities on you. These Terms and Conditions may result in you being responsible for paying additional costs and amounts and the Promoters may also have claims and other rights against you.
// Please read these Terms and Conditions carefully. Participation in this offer will constitute your agreement to comply with these Terms and Conditions. If you do not agree with these Terms and Conditions, please do not participate in this offer. It is specifically understood that Participation in the offer is qualified by your acceptance of the Terms and Conditions by way of click through thereof on your device

//         </p> */}
  
//   <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
//     <h2 className="text-2xl font-semibold mb-4">
//       <span className="mr-2 text-blue-500 ">→</span>  IMPORTANT NOTICE:
//     </h2>
//     <p>A. These Terms and Conditions contain assumptions of risk and/or liability by Customers and limit and exclude liabilities, obligations and legal responsibilities which STOS Gaming (“STOS”) and Vodacom will have towards Customers.
//  </p>
//     <p className="mt-2">B. These Terms and Conditions limit and exclude Customers’ rights and remedies and place various risks, liabilities, obligations and legal responsibilities on the Customer.
// </p>
//     <p className="mt-2">C. These Terms and Conditions may result in Customers being responsible for additional costs and allow STOS and Vodacom to assert claims and other rights.
// </p>
// <p className="mt-2">D. Where applicable, these Terms are subject to the Consumer Protection Act, 2008 (the “CPA”) and must be interpreted to ensure compliance with the CPA.
// </p>
// <p className="mt-2">E. By subscribing to the Kick n Winn service, the Customer acknowledges and agrees to these Terms and Conditions.</p>

    
//   </section>


//   <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
//     <h2 className="text-2xl font-semibold mb-4">
//       <span className="mr-2 text-blue-500">→</span> Promo Details:
//     </h2>
//     <p><b>1.</b> Kick n Winn is a value-added gaming service offered by STOS Gaming in partnership with Vodacom.</p>
//     {/* <p><b>2.</b> New customers are entitled to a 1-day free trial of the service.</p> */}
//     <p><b>2.</b>A fee of R9 per day will be charged, deducted directly from the customer's airtime.</p>
//     <p><b>3.</b> This is a daily recurring subscription unless the customer opts out.</p>


//   </section>


//   {/* <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
//     <h2 className="text-2xl font-semibold mb-4">
//       <span className="mr-2 text-blue-500">→</span> 3. Who is Eligible
//     </h2>
//     <p><b>3.1</b> The Service is available to all Econet’s subscribers who are natural persons with a valid Econet mobile number (“the Users”). Notwithstanding the aforesaid, it is agreed that only the Users who are using SIM cards to participate in the Service that have been RICA registered are eligible to win the Prizes.</p>
  
//   </section> */}


//   <section className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300 ">
//     <h2 className="text-2xl font-semibold mb-4">
//       <span className="mr-2 text-blue-500">→</span>  Subscription and Unsubscription:
//     </h2>
//     <p> <b>1.</b> Customers will receive an SMS confirmation upon successful subscription.</p>

//     <p><b>2.</b> To unsubscribe, Dial *135*997#.</p>
//     <p><b>3.</b>Standard data and SMS rates may apply. </p>
         

          
//     <strong>
//     Liability and Usage:          
//     </strong>

//   <p>
//   <b>1.</b>  STOS does not guarantee uninterrupted or error-free access to the Kick n Winn service.</p>
//   <p>
//   <b>2.</b> Users participate at their own risk and STOS is not liable for any losses incurred through participation or non-availability of the service.
//   </p>

          
//   <p>
//   <b>3.</b> The service is intended for entertainment purposes only.
//   </p>
   
//   </section>



// </div>
// </div>
// </>
//     // </Layout>
//   );
// }

// export default TermsAndCondition

import React from "react";
import logoAnimation from "../animations/logo.json";
import Lottie from "lottie-react";
import { FaGlobe } from "react-icons/fa";
import "./TermsAndCondition.css";

const SectionTitle = ({ children }) => (
  <h2 className="terms-section-title">{children}</h2>
);

const TermsAndCondition = () => {
  return (
    <div className="terms-page">

      {/* Header */}
      <header className="terms-header">

        <div className="terms-logo">
          <Lottie
            animationData={logoAnimation}
            loop={true}
            autoplay={true}
          />
        </div>

        <h1>Kick n Winn</h1>

        <p>Terms &amp; Conditions</p>

      </header>

      <div className="terms-divider"></div>

      {/* Content */}
      <main className="terms-content">

        {/* Disclaimer */}
        <section className="terms-section">

          <SectionTitle>Disclaimer</SectionTitle>

          <div className="terms-text">

            <p>
              STOS Gaming is a member of WASPA and is bound by the WASPA Code of Conduct.
            </p>

            <p>
              Customers have the right to approach WASPA to lodge a complaint
              in accordance with the WASPA complaints procedure.
            </p>

            <p>
              STOS Gaming may be required to share information relating to a
              service or customer with WASPA for the purpose of resolving a complaint.
            </p>

            <p>
              WASPA website:{" "}
              <a
                href="https://www.waspa.org.za"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.waspa.org.za
              </a>
            </p>

          </div>

        </section>


        {/* Service Information */}
        <section className="terms-section service-section">

          <SectionTitle>Service Information</SectionTitle>

          <div className="service-box">

            <p><strong>Service Name:</strong> Kick n Winn</p>

            <p><strong>Subscription Fee:</strong> R9/day</p>

            <p><strong>Age Restriction:</strong> 18 years and older</p>

            <p><strong>Permission:</strong> Bill payer's permission required</p>

            <p><strong>Compatible Devices:</strong> Compatible handsets only</p>

            <p><strong>Unsubscribe:</strong> Dial *135*997#</p>

            <p>
              <strong>Customer Care:</strong> panz.support1@panzcon.com
            </p>

          </div>

        </section>


        {/* Acceptable Use */}
        <section className="terms-section">

          <SectionTitle>Acceptable Use</SectionTitle>

          <div className="terms-text">

            <p>This service must not be used:</p>

            <ol className="acceptable-list">

              <li>To intentionally engage in illegal conduct.</li>

              <li>To knowingly create, store or disseminate illegal content.</li>

              <li>To knowingly infringe copyright.</li>

              <li>To knowingly infringe intellectual property rights.</li>

              <li>To send spam or promote the sending of spam.</li>

            </ol>

            <p className="terms-large-gap">
              We reserve the right to suspend or terminate the services of any
              customer who does not comply with these Terms and Conditions or any
              related contractual obligations.
            </p>

          </div>

        </section>


        {/* Service Provider */}
        <section className="terms-section">

          <SectionTitle>Service Provider</SectionTitle>

          <h3 className="provider-name">STOS Gaming</h3>

          <div className="terms-text provider-address">

            <p>PANZ Consultants DWC LLC</p>
            <p>Business Centre, Dubai World Central</p>
            <p>P.O. Box 390667, Dubai</p>
            <p>Trade License Number: 7139</p>
            <p>Corporate TRN (CTRN): 104528718000001</p>

          </div>

        </section>

      </main>


      {/* Floating Globe */}
      <button className="language-button" aria-label="Language options">
        <FaGlobe />
      </button>

    </div>
  );
};

export default TermsAndCondition;